<template>
  <section class="switch_container__info">
    <a class="info-button_popin" @click="togglePopin">
      <svg class="icon-info_small">
        <use xlink:href="#icon-Info_small" />
      </svg>
    </a>
    <lightbox :visible="lightboxVisible" @close="lightboxVisible = false">
      <div class="lightbox-simple-content">
        <ul>
          <li>
            <span v-html="lightBoxCopy.title" />
            <p v-html="lightBoxCopy.subtitle" />
          </li>
        </ul>
      </div>
    </lightbox>
  </section>
</template>

<script>
import Lightbox from "@/components/shared/LightBox";
export default {
  props: {
    lightBoxCopy: Object
  },
  data() {
    return {
      lightboxVisible: false
    };
  },
  components: {
    Lightbox
  },
  methods: {
    togglePopin() {
      this.lightboxVisible = !this.lightboxVisible;
    }
  }
};
</script>

<style>
</style>